import React from 'react';
import './Badge.css';

export default function Badge({ children, variant = 'format', className = '' }) {
  return (
    <span className={`badge badge-${variant} text-overline ${className}`}>
      {children}
    </span>
  );
}
